import {
	FIDELITY_PLANS_FROM_USER_SALES_RECEIVED,
	FIDELITY_PLANS_FROM_USER_SALES_EMPTY,
	FIDELITY_PLANS_RECEIVED,
	USER_PAYMENTS_HAS_ERROR,
	USER_PAYMENTS_RECEIVED,
	USER_PAYMENTS_WAS_REQUESTED,
	UTIL_DATA_WAS_REQUESTED
} from "../shared/constants";

const INITIAL_STATE = {
	fidelityPlans: [{}],
	fidelityPlansFromUserSales: [{}],
	isFetching: true,
	userPayments: {
		isFetching: false,
		payments: {}
	}
};

const UtilReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case UTIL_DATA_WAS_REQUESTED:
			return {
				...state,
				isFetching: true
			};
		case FIDELITY_PLANS_RECEIVED:
			return {
				...state,
				fidelityPlans: action.payload,
				isFetching: false
			};
		case FIDELITY_PLANS_FROM_USER_SALES_RECEIVED:
			return {
				...state,
				fidelityPlansFromUserSales: action.payload.data,
				isFetching: false
			};
		case FIDELITY_PLANS_FROM_USER_SALES_EMPTY:
			return {
				...state,
				fidelityPlansFromUserSales: [],
				isFetching: false
			};
		case USER_PAYMENTS_WAS_REQUESTED:
			return {
				...state,
				userPayments: {
					isFetching: true,
					payments: {}
				}
			};
		case USER_PAYMENTS_HAS_ERROR:
			return {
				...state,
				userPayments: {
					isFetching: false,
					hasError: true,
					payments: {}
				}
			};
		case USER_PAYMENTS_RECEIVED:
			return {
				...state,
				userPayments: {
					isFetching: false,
					payments: action.payload
				}
			};

		default:
			return state;
	}
};

export default UtilReducer;
